import { Helmet } from 'react-helmet'
import { Link } from "react-router-dom"
import npair from '../../assets/images/slide-novWine.jpg'
import thanks from '../../assets/images/slide-thanks.jpg'
import holi from '../../assets/images/menu-holidaySeason.png'
import dpair from '../../assets/images/slide-decPair.jpg'
import xmas from '../../assets/images/slide-xmas.jpg'
import holidayEvents from '../../HolidaySeason.pdf'
import xmasMenu from '../../ChristmasDinner.pdf'
import dpairMenu from '../../DecemberWine.pdf'

export default function EventList(){
  return (
    <div className="pageStyles eventList">
      <Helmet>
        <title>Delicious Events at Villaggio Grille</title>
        <meta name="description" content="Don't miss these upcoming events and experiences at Villaggio Grille. Your taste buds will thank you!" />
      </Helmet>

      <div className="simpleBanner">
        <div className="sbWrap kpWrapXl">
          <h1>Upcoming Events at Villaggio</h1>
          <p className="instr">Select an event from the list below to learn more.</p>
        </div>
      </div>

      <div className="fullSec eventGrid">
        <div className="sectionWrap kpWrapXl">
          <div className="hlf rightSide">
            <div className="item i1 npair"><Link to="/pairing"><img src={npair} alt="Villaggio - November Wine Pairing" /></Link></div>
            <div className="item i2 thanks"><Link to="/thanksgiving"><img src={thanks} alt="View Villaggio's Thanksgiving menu" /></Link></div>
            <div className="item i4 dpair"><a href={dpairMenu} target="_blank" rel="noreferrer"><img src={dpair} alt="December Wine Pairing at Villaggio" /></a></div>
            <div className="item i5 xmas"><a href={xmasMenu} target="_blank" rel="noreferrer"><img src={xmas} alt="Villaggio Christmas menu" /></a></div>
          </div>
          <div className="hlf leftSide stickyNn">
            <a href={holidayEvents} target="_blank" rel="noreferrer"><img src={holi} alt="Villaggio Holiday Event Schedule" /></a>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
